//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import OrcamentoTabela from './orcamento/OrcamentoTabelaDash';
import orcamentoMixin from './orcamento/orcamento';
import SaldoRepresentante from './orcamento/SaldoRepresentante';
import BoxValoresRepresentante from './orcamento/BoxValoresRepresentante';

import { skipLoading } from '../../../../../common/functions/loading';

export default {
  name: 'DashboardPlanejamento',
  mixins: [orcamentoMixin],
  data() {
    return {
      dashboardOrcamentoResources: this.$api.dashboardOrcamento(this.$resource),
      workflowOrcamentoResources: this.$api.workflowOrcamento(this.$resource),
      usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
      anos: [],
      ano: null,
      consolidadoPlanejado: null,
      currentData: null,
      unidadesNegocio: [],
      idUnidadeNegocio: null,
      orcamentosListItens: [],
      lastSearchTableSize: 0,
      saldoRepresentante: null,
      carregado: false,
      carregandoBox: false,
      carregandoTable: false,
      bloquearConsulta: false,
      filtros: {},
      paginas: 0,
      idOrcamento: null,
      buscarComParametro: false,
    };
  },
  props: {
    parametros: {
      type: Object,
      default: {},
    },
  },
  components: {
    OrcamentoTabela,
    BoxValoresRepresentante,
  },
  methods: {
    getAnos() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.dashboardOrcamentoResources.anos()
          .then((res) => {
            this.anos = res.data;
            // Padrão é o ano atual
            const atual = moment().format('YYYY');
            const anoAtual = { ano: Number(atual) };
            if (!this.searchInYears(anoAtual)) {
              this.anos.push(anoAtual);
            }
            this.podeIniciarBuscaFluxos = true;
            resolve();
          })
          .catch(reject);
      });
    },
    searchInYears(ano) {
      let success = false;
      this.anos.forEach((el) => {
        if (el.ano === ano.ano) {
          success = true;
        }
      });
      return success;
    },
    requestCargaMinhasAprovacoes(params = {}, pagina = 0) {
      this.bloquearConsulta = true;
      if (params.status) {
        this.filtros.status = params.status;
      } else if (this.filtros.status === undefined) {
        this.filtros.status = 'AGUARDANDO_APROVACAO';
      }
      if (params.fluxo) {
        this.filtros.fluxo = params.fluxo;
      } else {
        delete this.filtros.fluxo;
      }
      if (!params.dataInicio && this.ano) {
        this.filtros.ano = this.ano;
      } else {
        delete this.filtros.ano;
      }
      if (params.tipo) {
        this.filtros.tipo = params.tipo;
      } else {
        delete this.filtros.tipo;
      }
      if (params.idsMarcas) {
        this.filtros.idsMarcas = params.idsMarcas;
      } else {
        delete this.filtros.idsMarcas;
      }
      if (params.dataInicio) {
        this.ano = null;
        this.filtros.dataInicio = params.dataInicio;
      } else {
        delete this.filtros.dataInicio;
      }
      if (params.dataFim) {
        this.filtros.dataFim = params.dataFim;
      } else {
        delete this.filtros.dataFim;
      }
      if (params.descricao) {
        this.filtros.descricao = params.descricao;
      } else {
        delete this.filtros.descricao;
      }
      this.filtros.meuPassoPendente = params.meuPassoPendente;
      this.filtros.meuPassoAprovado = params.meuPassoAprovado;
      if (this.filtros.meuPassoAprovado) {
        this.filtros.status = undefined;
      }

      if (params.idOrcamento) {
        this.filtros.idOrcamento = params.idOrcamento;
      }

      this.filtros.tamanhoPagina = 10;
      this.filtros.numeroPagina = pagina;

      skipLoading();
      this.carregandoTable = true;
      this.dashboardOrcamentoResources.fluxos(this.filtros).then((response) => {
        this.bloquearConsulta = false;
        delete this.filtros.idOrcamento;
        const fluxos = response.data.resposta;
        this.lastSearchTableSize = fluxos.length;

        const qtdeRegistros = response.data.quantidadeRegistrosPagina;
        this.paginas = Math.ceil(qtdeRegistros / this.filtros.tamanhoPagina);

        this.orcamentosListItens = [];
        this.orcamentosListItens.push(...fluxos);
        this.orcamentosListItens.forEach((item) => {
          item.selecionado = false;
        });
        this.carregandoTable = false;
      })
      .catch((err) => {
        this.$error(this, err);
        this.bloquearConsulta = false;
        this.carregandoTable = false;
      });
    },
    carregarValoresConsolidadosOrcamentos() {
      skipLoading();
      this.carregandoBox = true;
      if (this.ano) {
        this.filtros.ano = this.ano;
      } else {
        delete this.filtros.ano;
      }
      this.dashboardOrcamentoResources.buscarPlanejado(this.filtros)
        .then((res) => {
          this.saldoRepresentante = new SaldoRepresentante(res.data);
          this.carregandoBox = false;
        })
        .catch((err) => {
          this.$error(this, err);
          this.carregandoBox = false;
        });

      this.$forceUpdate();
    },
    requestGetUnidadesNegocio() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.usuarioUnidadeNegocioResources.listarAtivos()
          .then((response) => {
            this.unidadesNegocio = response.data;
            resolve();
          })
          .catch(reject);
      });
    },
    filtrarFluxos(filtro) {
      this.$refs.orcamentoTabela.refazPaginacao();
      if (this.buscarComParametro) {
        this.requestCargaMinhasAprovacoes(this.filtrosPorParametros());
        this.buscarComParametro = false;
      } else {
        this.requestCargaMinhasAprovacoes(filtro);
      }
    },
    recarregarDashboard() {
      this.$refs.orcamentoTabela.refazPaginacao();
      if (this.ano) {
        this.filtros.ano = this.ano;
      } else {
        delete this.filtros.ano;
      }
      if (this.idUnidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.idUnidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.carregarValoresConsolidadosOrcamentos();
      this.requestCargaMinhasAprovacoes(this.filtrosPorParametros());
    },
    filtrosPorParametros() {
      const filter = { status: null };
      if (this.parametros && this.parametros.idOrcamento) {
        filter.idOrcamento = this.parametros.idOrcamento;
      }
      return filter;
    },
    temParametro() {
      return this.parametros && this.parametros.idOrcamento;
    },
    abreCarrega() {
      if (this.carregado) {
        return;
      }

      window.setTimeout(() => {
        this.getAnos()
          .then(this.requestGetUnidadesNegocio)
          .then(() => {
            this.filtros.ano = this.ano;
            this.carregarValoresConsolidadosOrcamentos();
            if (this.temParametro()) this.buscarComParametro = true;
            this.carregado = true;
          })
          .catch((err) => {
            this.$toast.create(this.$t(err), 'snack', 3E3);
          });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardPlanejamento.vue?vue&type=script&lang=js&